import React, { useEffect } from 'react';
import { TiSocialFacebook, TiSocialTwitter, TiSocialInstagram, TiSocialLinkedin } from "react-icons/ti";
import { FaMapMarkerAlt, FaEnvelope, FaPhoneAlt } from 'react-icons/fa';

function ContactForm() {
  return (
    <div className="flex items-center justify-center min-h-screen bg-gradient-to-r from-blue-50 to-purple-50 pt-36 pb-20  px-[3%] md:px-[5%] lg:px-[10%]">
      <div className="relative z-10 w-full max-w-3xl grid grid-cols-1 md:grid-cols-2 bg-white shadow-xl rounded-3xl overflow-hidden">
        {/* Contact Info */}
        <div className="p-4 sm:p-8 bg-gradient-to-b from-[#551E19] to-[#7B352D] text-[#E6B17E]">
          <h3 className="text-2xl md:text-4xl font-semibold mb-6">Let's get in touch</h3>
          <div className='flex flex-col justify-between'>
            <div>
              <p className="mb-6 text-sm leading-relaxed text-white text-justify">
                We are here to help with any questions, feedback, or inquiries you may have. Feel free to reach out to us!
              </p>

              <div className="space-y-6">
                <div className="flex items-center space-x-4">
                  <FaMapMarkerAlt className="w-6 h-6 text-[#E6B17E]" />
                  <p className="text-sm text-white">179/1B, Goluwawila, Ratnapura.</p>
                </div>
                <div className="flex items-center space-x-4">
                  <FaEnvelope className="w-6 h-6 text-[#E6B17E]" />
                  <p className="text-sm text-white">poopooshop13@gmail.com</p>
                </div>
                <div className="flex items-center space-x-4">
                  <FaPhoneAlt className="w-6 h-6 text-[#E6B17E]" />
                  <p className="text-sm text-white">+94-76-8262939</p>
                </div>
              </div>
            </div>

            <div className="mt-8">
              <p className="text-lg font-normal text-white">Connect us :</p>
              <div className="flex space-x-4 mt-4">
                <a href="https://www.facebook.com/profile.php?id=61560774282709&mibextid=LQQJ4d" className="text-[#E6B17E] hover:text-[#FFDD57] transition duration-300 border rounded-full p-1">
                  <TiSocialFacebook size={16} />
                </a>
                <a href="#" className="text-[#E6B17E] hover:text-[#FFDD57] transition duration-300 border rounded-full p-1">
                  <TiSocialTwitter size={16} />
                </a>
                <a href="https://www.instagram.com/moramerc_?igsh=dHFrZG9wdGQ0ajhv" className="text-[#E6B17E] hover:text-[#FFDD57] transition duration-300 border rounded-full p-1">
                  <TiSocialInstagram size={16} />
                </a>
                <a href="#" className="text-[#E6B17E] hover:text-[#FFDD57] transition duration-300 border rounded-full p-1">
                  <TiSocialLinkedin size={16} />
                </a>
              </div>
            </div>
          </div>
        </div>

        {/* Contact Form */}
        <div className="p-4 sm:p-8 bg-white flex flex-col justify-center">
          <form className="space-y-4">
            <h3 className="text-2xl md:text-3xl font-semibold text-[#551E19] mb-4 text-center">Contact us</h3>
            
            <div className="relative">
              <label htmlFor="name" className="block text-sm font-medium text-[#551E19]">Name</label>
              <input type="text" name="name" id="name" className="w-full px-4 py-2 mt-1 border-2 border-[#551E19] rounded-md focus:ring-2 focus:ring-[#E6B17E] focus:outline-none transition duration-300" />
            </div>

            <div className="relative">
              <label htmlFor="email" className="block text-sm font-medium text-[#551E19]">Email</label>
              <input type="email" name="email" id="email" className="w-full px-4 py-2 mt-1 border-2 border-[#551E19] rounded-md focus:ring-2 focus:ring-[#E6B17E] focus:outline-none transition duration-300" />
            </div>

            <div className="relative">
              <label htmlFor="phone" className="block text-sm font-medium text-[#551E19]">Phone</label>
              <input type="tel" name="phone" id="phone" className="w-full px-4 py-2 mt-1 border-2 border-[#551E19] rounded-md focus:ring-2 focus:ring-[#E6B17E] focus:outline-none transition duration-300" />
            </div>

            <div className="relative">
              <label htmlFor="message" className="block text-sm font-medium text-[#551E19]">Message</label>
              <textarea name="message" id="message" rows="3" className="w-full px-4 py-2 mt-1 border-2 border-[#551E19] rounded-md focus:ring-2 focus:ring-[#E6B17E] focus:outline-none transition duration-300"></textarea>
            </div>

            <button type="submit" className="w-full mx-auto py-2 px-8 bg-[#E6B17E] text-[#551E19] font-bold rounded-xl hover:bg-[#551E19] hover:text-white transition duration-500 transform hover:scale-103">
              Send
            </button>
          </form>
        </div>
      </div>
    </div>
  );
}

export default ContactForm;